import { getDictCodes } from '@/api/system/dict';
import {
  getSaleSchemeList,
  addSaleScheme,
  getProductList,
  getPartnerList,
  getWithdrawLogs,
  getIncomeLogs,
  getBindedDevices,
  deleteSaleScheme,
  approveRequire,
  submitApprove
} from '@/api/partner';

const state = {
  activiedTab: '1',
  total: 0,
  dicts: {
    'PARTNER_STATUS': null,
    'APPROVE_STATUS': null,
    'PARTNER_INCOME_STATUS': null,
    'PARTNER_INCOME_TYPE': null,
    'REFUND_STATUS': null
  },
  withdrawList: [],
  incomeList: [],
  partnerList: [],
  bindedLogs: [], // 绑定设备记录
  memberProdList: [], // 企业会员商品列表
  salesSchemeList: [{
    id: 1,
    name: '测试'
  }]
};

const mutations = {
  CHANGE_TAB: (state, tabId) => {
    state.activiedTab = tabId;
  },
  UPDATE_DICTS: (state, [dicts, code]) => {
    state.dicts[code] = dicts;
  },
  SET_PRODUCT_OPTIONS: (state, list) => {
    state.memberProdList = list;
  },
  UPDATE_SCHEMES_LIST: (state, list) => {
    state.salesSchemeList = list;
  },
  UPDATE_PARTNER_LIST: (state, list) => {
    state.partnerList = list;
  },
  UPDATE_BINDED_DEVICE_LIST: (state, list) => {
    state.bindedLogs = list;
  },
  UPDATE_WITHDRAW_LIST: (state, list) => {
    state.withdrawList = list;
  },
  UPDATE_INCOME_LIST: (state, list) => {
    state.incomeList = list;
  },
  UPDATE_TOTAL: (state, total) => {
    state.total = total;
  }
};

const actions = {
  // 本地，线上tabs切换
  changeTab({ commit }, tabId) {
    commit('CHANGE_TAB', tabId);
  },
  // 合伙人营销配置列表数据
  getSalesSchemes({ commit }, payload) {
    return getSaleSchemeList(payload).then(({ data: res }) => {
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_SCHEMES_LIST', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 删除营销配置
  deleteSaleScheme(_ctx, payload) {
    return deleteSaleScheme(payload).then(({ data: res }) => {
      if (res.code === 200) {
        return true;
      }
    })
  },
  addSaleScheme(_ctx, data) {
    return addSaleScheme(data).then(({ data: res }) => {
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 提交审核
  approveRequire(_ctx, payload) {
    return approveRequire(payload).then(({ data: res }) => {
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 处理审核
  handleApporveFlow(_context, payload) {
    return submitApprove(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        return true;
      }
    })
  },
  // 会员商品选项
  getProductList({ commit }) {
    return getProductList().then(({ data: res }) => {   
      if (res.code === 200) {
        commit('SET_PRODUCT_OPTIONS', res.data || []);
      }
    })
  },
  // 合伙人管理列表
  getPartnerList({ commit }, payload) {
    return getPartnerList(payload).then(({ data: res }) => {
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_PARTNER_LIST', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 绑定设备记录列表
  getBindedDeviceList({ commit }, payload) {
    return getBindedDevices(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_BINDED_DEVICE_LIST', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 获取提现记录
  getWithdrawLogs({ commit }, payload) {
    return getWithdrawLogs(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_WITHDRAW_LIST', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  // 收益记录
  getIncomeLogs({ commit }, payload) {
    return getIncomeLogs(payload).then(response => {
      const res = response.data;
      if (res.code === 200) {
        const data = res.data || {};
        commit('UPDATE_INCOME_LIST', data.records || []);
        commit('UPDATE_TOTAL', data.total);
      }
    })
  },
  getDicts({ commit }, code) {
    // if is exist will resolve soon
    getDictCodes(code).then(response => {
      const res = response.data;
      if (res.code === 200) {
        commit('UPDATE_DICTS', [res.data, code]);
      }
    })
  },
};

const getters = {
  approveStatusOptions: state => {
    return state.dicts['APPROVE_STATUS'] || [];
  },
  partnerStatusOptions: state => {
    return state.dicts['PARTNER_STATUS'] || [];
  },
  refundStatusOptions: state => {
    return state.dicts['REFUND_STATUS'] || [];
  },
  incomeTypeOptions: state => {
    return state.dicts['PARTNER_INCOME_TYPE'] || [];
  },
  incomeStatusOptions: state => {
    return state.dicts['PARTNER_INCOME_STATUS'] || [];
  },
  withdrawStatusOptions: state => {
    return state.dicts['WITHDRAW_STATUS'] || [];
  },
  withdrawTypes: state => (state.dicts['WITHDRAW_TYPES'] || [])
};

export default { state, mutations, actions, getters, namespaced: true };
